/*
 * Twitter Bootstrap 4 plugin for AngularJS.
 * Copyright (c) 2016-2021 Rodziu <mateusz.rohde@gmail.com>
 * License: MIT
 */
export class ModalProvider {
    constructor() {
        this.config = {
            backdrop: 'static',
            keyboard: true,
            transitionDuration: 300,
            backdropTransitionDuration: 150,
            onBeforeChange: () => true
        };
        this.backdropController = null;
    }
    $get() {
        return this;
    }
}
